import { Text, View } from "@react-pdf/renderer";
import { globalStyles } from "config/pdfStyles";
import { dateFormat, userFullNameReverse } from "helpers/common";
import moment from "moment";

const ReportFooter = ({ data }) => {
  return (
    <View style={globalStyles.footerContainer} fixed>
      <View style={[globalStyles.section, globalStyles.footer]} >
          {data && (
            <Text>{userFullNameReverse(data, null)}</Text>
          )}
          <View style={{ flexDirection: "row" }}>
            <Text style={{ marginRight: 5 }}>{dateFormat(moment())}</Text>
            <Text
              render={({ pageNumber, totalPages }) => (
                  `${pageNumber}/${totalPages}`
              )}
            />
          </View>
      </View>
    </View>
  )
}

export default ReportFooter;